import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
jQuery(document).ready(function ($) {
  var selectedValues = [];

  /*** auto. find new combination if unavailble variation is chosen *****/
  jQuery('form.variations_form ul.variable-items-wrapper').on('click', 'li.variable-item.disabled', function () {
    var _this = this;
    selectedValues = [];
    var clickedAttribute = $(this).parent().attr('data-attribute_name');

    /**** Keep existing choices to try to find a new variation with these ****/
    /**** Exclude the clicked attribute — we are intentionally changing it ****/
    jQuery('li.selected').each(function () {
      var currentAttribute = $(this).parent().attr('data-attribute_name');
      if (currentAttribute === clickedAttribute) {
        return;
      }
      var dataVal = $(this).attr('data-value');
      selectedValues.push('ul[data-attribute_name="' + currentAttribute + '"] li[data-value="' + dataVal + '"]');
    });
    /*************************************************************************/

    $('a.reset_variations').trigger('click');
    setTimeout(function () {
      $(_this).trigger('click');
    }, 0);
  });

  /*** automatically choose attribute if only one available *****/
  jQuery('form.variations_form ul.variable-items-wrapper').on('click', 'li.variable-item:not(.disabled)', function () {
    setTimeout(function () {
      //only if we haven't found a variation so far
      if (jQuery('.variation_id').val() === '') {
        var i = selectedValues.length;

        /**** If we have preselected choices try to activate those first */
        while (i--) {
          if ($(selectedValues[i] + ':not(.disabled):not(.selected)').length) {
            var attrButton = $(selectedValues[i] + ':not(.disabled):not(.selected)');
            selectedValues.splice(i, 1);
            attrButton.trigger('click');
            return false;
          }
          selectedValues.splice(i, 1);
        }
        /*****************************************************************/

        jQuery('table.variations tbody tr').each(function () {
          //if no attribute has been selected so far and one one possible variation is available then activate it
          if (!jQuery(this).find('li.variable-item.selected').length && jQuery(this).find('li.variable-item:not(.disabled)').length === 1) {
            jQuery(this).find('li.variable-item:not(.disabled)').trigger('click');
            return false;
          }
        });
      }
    }, 0);
  });

  //scoped to the gallery: the theme hardcodes .load-labels on every teaser label container too - those must never be replaced
  var labels_selector = '.xts-single-product-images-wrapper .load-labels';
  var cache_labels = [];
  if ($('.xts-content-area > .product-type-simple').length) {
    load_labels($('#simple-product-id').val());
  }
  function load_labels(product_id) {
    var is_quick_view = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!cache_labels.hasOwnProperty(product_id) || is_quick_view) {
      jQuery(labels_selector).html('<span class="loading-animation bg-transparent xts-product-label h-[24px]"></span>');
      jQuery.get("/wp/wp-admin/admin-ajax.php", {
        action: 'load_labels',
        product_id: product_id
      }).then(function (result) {
        cache_labels[product_id] = result;
        load_labels_func(result, is_quick_view);
      });
    } else {
      load_labels_func(cache_labels[product_id], is_quick_view);
    }
  }
  function load_labels_func(result, is_quick_view) {
    var container = jQuery(labels_selector);
    if (result !== '') {
      container.replaceWith(result);
    } else {
      container.replaceWith('<div class="xts-product-labels load-labels"></div>');
    }
  }
  function update_stock_meta_section(stock_html, form) {
    jQuery(form).closest('.summary').find('.filter-data-wrapper.lieferung .stock-copy-into').html(stock_html);
  }
  function update_description(short_description, long_description) {
    jQuery('.woocommerce-product-details__short-description').html((short_description + long_description).trim());
  }
  function update_verkaufseinheit_meta_section(verkaufseinheit, form) {
    if (verkaufseinheit === '') {
      jQuery(form).closest('.summary').find('.filter-data-wrapper.verkaufseinheit').addClass('hidden');
    } else {
      jQuery(form).closest('.summary').find('.filter-data-wrapper.verkaufseinheit').removeClass('hidden');
      jQuery(form).closest('.summary').find('.filter-data-wrapper.verkaufseinheit .filter-val').html(verkaufseinheit);
    }
  }
  function update_voc_meta_section(voc, form) {
    if (voc === '') {
      jQuery(form).closest('.summary').find('.filter-data-wrapper.voc-abgabe').addClass('hidden');
    } else {
      jQuery(form).closest('.summary').find('.filter-data-wrapper.voc-abgabe').removeClass('hidden');
      jQuery(form).closest('.summary').find('.filter-data-wrapper.voc-abgabe .filter-val').html(voc);
    }
  }

  /*** Preis auf Anfrage (price 0): request form instead of cart button *****/
  function toggle_request_form(variation, form) {
    var wrap = $('#anfrage');
    if (!wrap.length) {
      return;
    }
    var on_request = !!(variation && variation.request_price);
    wrap.toggleClass('hidden', !on_request);
    $(form).toggleClass('price-on-request', on_request);
    if (on_request) {
      wrap.find('input[name="field-prod-sku"]').val(variation.sku || $('.product_meta .sku').text().trim());

      //allow a new request after switching to another variation
      wrap.find('form.wpcf7-form.sent').removeClass('sent').addClass('init').attr('data-status', 'init');
    }
  }
  $(document).on('click', '.toggle-anfrage-form', function (e) {
    e.preventDefault();
    $(this).closest('#anfrage').find('.anfrage-form-panel').slideToggle();
  });
  /**************************************************************************/

  $(document).on('found_variation', function (event, variation) {
    update_stock_meta_section(variation.availability_html, event.target);
    update_verkaufseinheit_meta_section(variation.verkaufseinheit, event.target);
    update_voc_meta_section(variation.voc, event.target);
    update_description(variation.short_description, variation.description);
    load_labels(variation.variation_id, true);
    check_stock_toast(event.target);
    toggle_request_form(variation, event.target);
  });

  /*** partial-stock toast: warn when ordered qty exceeds stock *****/
  var stock_toast_timeout;
  function stock_toast_message(stock_qty, backorder_message) {
    var stock_part = stock_qty === 1 ? 'Es ist nur 1 Stück an Lager. ' : 'Es sind nur ' + stock_qty + ' Stück an Lager.<br/>';
    var rest_part = backorder_message ? 'Der Rest: ' + backorder_message + '.' : 'Der Rest wird nachbestellt.';
    return '<strong>Achtung</strong>: ' + stock_part + rest_part;
  }
  function show_stock_toast(message) {
    var toast = $('.stock-toast');
    if (!toast.length) {
      toast = $('<div class="stock-toast" role="alert">' + '<span class="stock-circle orange"></span>' + '<p class="stock-toast-message"></p>' + '<button type="button" class="stock-toast-close" aria-label="Schliessen">&times;</button>' + '</div>').appendTo('body');
    }
    toast.find('.stock-toast-message').html(message);
    toast.addClass('visible');
    clearTimeout(stock_toast_timeout);
    stock_toast_timeout = setTimeout(hide_stock_toast, 8000);
  }
  function hide_stock_toast() {
    clearTimeout(stock_toast_timeout);
    $('.stock-toast').removeClass('visible');
  }
  function check_stock_toast(form) {
    var qty = parseInt($(form).find('input.qty').val(), 10) || 0;
    var header = $(form).closest('.summary').find('.filter-data-wrapper.lieferung .stock-infoheader[data-stock-qty]');
    var stock_qty = parseInt(header.attr('data-stock-qty'), 10);
    if (stock_qty > 0 && qty > stock_qty) {
      show_stock_toast(stock_toast_message(stock_qty, header.attr('data-backorder-message') || ''));
    } else {
      hide_stock_toast();
    }
  }
  $(document).on('change input', 'form.cart input.qty', function () {
    check_stock_toast($(this).closest('form.cart'));
  });
  $(document).on('reset_data', function (event) {
    update_stock_meta_section('', event.target);
    hide_stock_toast();
    toggle_request_form(null, event.target);
  });
  $(document).on('click', '.stock-toast-close', hide_stock_toast);
  /******************************************************************/

  function getUrlParams() {
    var params = {};
    window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
      params[key] = decodeURIComponent(value);
    });
    return params;
  }
  var params = getUrlParams();

  // Other attributes (select dropdowns)
  $('form.variations_form select').each(function () {
    var name = $(this).attr('name');
    if (params[name]) {
      $(this).val(params[name]).trigger('change');
    }
  });
  jQuery(document).on('click', '.xts-single-product-images-wrapper .xts-single-product-images .woocommerce-product-gallery__image.swiper-slide-active', function () {
    jQuery('.xts-photoswipe-btn a').trigger('click');
  });
});